"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = __importStar(require("react"));
const classnames_1 = __importDefault(require("classnames"));
const divider_1 = __importDefault(require("./divider"));
const header_1 = __importDefault(require("./header"));
const menu_1 = __importDefault(require("./menu"));
const menuItem_1 = __importDefault(require("./menuItem"));
const slot_1 = __importDefault(require("./slot"));
require("@hotmart/cosmos/dist/dropdown");
const Dropdown = (0, react_1.forwardRef)(({ children, className, docked, position = 'bottom' }, ref) => {
    const classes = (0, classnames_1.default)(className, `hot-drop${position}`, {
        'hot-dropdocked': docked
    });
    return ((0, jsx_runtime_1.jsx)("hot-dropdown", { ref: ref, class: classes, children: children }));
});
const CompoundDropdown = Object.assign(Dropdown, {
    Slot: slot_1.default,
    Header: header_1.default,
    Divider: divider_1.default,
    Menu: menu_1.default,
    MenuItem: menuItem_1.default
});
exports.default = CompoundDropdown;
